import css from 'styled-jsx/css';

export default css`
  .main-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 4%;
    flex-direction: column;
  }
  .header-container {
    width: 54%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .header {
    display: flex;
    justify-content: center;
    align-items: baseline;
    width: 100%;
  }
  .header-icon {
    width: 22.26px;
    height: 29px;
    margin-right: 1%;
  }
  .title {
    font-size: 32px;
    font-family: 'big_noodle_titling';
    margin-bottom: 0;
    margin-top: 0;
  }
  .description{
    font-size: 16px;
    text-align: center;
  }
  .input-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .input-container {
    display: flex;
    justify-content: center;
    align-items: baseline;
    flex-direction: column;
  }
  .label-container {
    padding-top: 10px;
    padding-bottom: 5px;
  }
  .label {
    font-size: 15px;
    font-weight: 500;
  }
  .required {
    padding-left: 2px;
    color: #FF0000;
  }
  .input {
    width: 391px;
    height: 46px;
    border-radius: 3px;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .input::placeholder, textarea::placeholder{
    font-style: italic;
  }
  .textarea {
    width: 807px;
    height: 162px;
    padding: 10px;
  }
  .counter-container {
    display: flex;
    justify-content: end;
    align-items: center;
  }
  .counter {
    color: #999999;
    font-size: 15px;
    margin: 0 10px 0 0;
  }
  .submit-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .submit {
    display: flex;
    height: 40.4px;
    width: 219px;
    background-color: #950810;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 40px;
    text-align: center;
    border: none;
    color: white;
    border-radius: 3px;
    width: 200px;
    justify-content: center;
  }
  .input-section-desktop {
    display: inherit;
  }
  .input-section-mobile {
    display: none;
  }
  .input-mobile {
    width: 295px;
    height: 46px;
    border-radius: 3px;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 15px;
    border: none;
  }
  .input-mobile::placeholder {
    font-weight: bold;
  }
  @media (max-width: 991px) {
    .input {
      width: 280px;
    }
    .textarea {
      width: 580px;
    }
  }
  @media (max-width: 600px) {
    .main-container {
      margin-top: 10%;
    }
    .header-container {
      width: 87%;
    }
    .description {
      font-size: 12px;
      line-height: 25px;
    }
    .input-section-desktop {
      display: none;
    }
    .input-section-mobile {
      display: inherit;
    }
    .submit-container {
      margin-top: 5%;
      margin-bottom: 5%;
    }
  }
  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
    width: 1em;
    height: 1em;
    animation-fill-mode: both;
    animation: bblFadInOut 1.8s infinite ease-in-out;
  }
  .loader {
    color: #fff;
    font-size: 5px;
    position: relative;
    text-indent: -9999em;
    transform: translateZ(0);
    animation-delay: -0.16s;
    margin-top: 10px;
    margin-left: 13px;
  }
  .loader:before,
  .loader:after {
    content: "";
    position: absolute;
    top: 0;
  }
  .loader:before {
    left: -2em;
    animation-delay: -0.32s;
  }
  .loader:after {
    left: 2em;
  }

  @keyframes bblFadInOut {
    0%,
    80%,
    100% {
      box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
      box-shadow: 0 2.5em 0 0;
    }
  }
  @media (max-width: 768px) {
    .sub-container {
      width: 100%;
      padding-bottom: 2%;
    }
    .contact-box-btn {
      width: 100%;
      font-size: 12px;
    }
    @keyframes bblFadInOut {
      0%,
      80%,
      100% {
        box-shadow: 0 2em 0 -1.3em;
      }
      40% {
        box-shadow: 0 2em 0 0;
      }
    }
  }
`;